import { ModalViewModel } from '@/infra/ModalViewModel'
import { action, observable } from 'mobx'
import type {
  BulkActionError,
  BulkActionJob,
} from '@/features/jobs/list/bulk-actions'

/**
 * A job a bulk action could not be applied to.
 */
export interface BulkActionJobError {
  jobId: string
  jobTitle: string
  error: string
}

/**
 * Lists the jobs a bulk action could not be applied to.
 */
export class BulkActionJobErrorDialogViewModel {
  /**
   * View model for the underlying modal.
   */
  readonly modal = new ModalViewModel()

  /**
   * The jobs the last bulk action failed for.
   */
  @observable accessor errors: BulkActionJobError[] = []

  /**
   * Shows the errors, resolving each job's short ID and title from the jobs
   * the action ran on.
   */
  @action.bound
  showErrors(errors: BulkActionError[], jobs: readonly BulkActionJob[]) {
    this.errors = errors.map((error) => {
      const job = jobs.find((j) => j.id === error.jobId)
      return {
        error: error.error,
        jobId: job?.shortId || '',
        jobTitle: job?.displayName || '',
      }
    })
    this.modal.show()
  }
}
